
export function jsonFormData(config){
  const formData = new FormData();
  //循环传入的值转换formData
  Object.keys(config).forEach((key) => {
    formData.append(key, config[key]);
  })
  return formData;
}





// WEBPACK FOOTER //
// ./src/utils/jsonFormData.js